import { render, staticRenderFns } from "./notificationModal.vue?vue&type=template&id=e4f11f3c&scoped=true"
import script from "./notificationModal.vue?vue&type=script&lang=js"
export * from "./notificationModal.vue?vue&type=script&lang=js"
import style0 from "./notificationModal.vue?vue&type=style&index=0&id=e4f11f3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f11f3c",
  null
  
)

export default component.exports